import React from "react";
import { tspErrorMessage } from "../../hooks/useTspApiResource";

// A page (or section) whose data could not be loaded: the real reason, and a
// retry. Used instead of ever falling back to made-up data.
export default function TspLoadError({ error, onRetry, what = "this" }) {
  return (
    <div className="tsp-page tsp-dashboard-error" role="alert">
      <p>{tspErrorMessage(error, `Could not load ${what}.`)}</p>
      {onRetry && (
        <button type="button" className="tsp-btn tsp-btn-outline tsp-btn-sm" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
